import { QueryClient } from 'react-query';
import { DEFAULT_READING_LIST } from '../../../pages/MyContent/ArticlesTab/ArticlesTab.constants';
import { queryKeys } from '../../queryKeyFactory';

export const invalidateReadingListQueries = (queryClient: QueryClient): void => {
  queryClient.invalidateQueries(queryKeys.fetchReadingLists.defaultReadingList(DEFAULT_READING_LIST, undefined)[0]);
  queryClient.invalidateQueries(queryKeys.fetchReadingLists.defaultReadingListWithTags(undefined)[0]);
  queryClient.invalidateQueries([queryKeys.fetchReadingLists.all]);
};
